import React, { useEffect, useState } from "react"
import intl from "react-intl-universal"
import IconCiq from "../../../../../assets/icons/CIQIcon"
import ContentBlank from "../../../../molecules/ContentBlank"

import RcmpHeader from "../../../../atoms/Header"
import "./style.css"
import { useNavigate } from "react-router-dom"
import RcmpLoading from "../../../../atoms/Loading"
import NothingIcon from "../../../../../assets/icons/NothingIcon.svg"
import IAtom from "../../../../../assets/icons/IAtom"
import IControl from "../../../../../assets/icons/Control"
import IEqp from "../../../../../assets/icons/Equipment"
import { FilterDashboard } from "../../components/FiltersDashboardCiq"
import { LineChartComponent } from "../../components/LineChart"
import styles from "./index.module.scss"
import { EquipmentAtention } from "../../components/EquipmentAtention"
import { FilterAttentionPoints } from "../../components/FilterAttentionPoints"
import { ParetoChartComponent } from "../../components/ParetoChart"
import useDataApi from "../../../../../hooks/useDataApi"
import {
  getDashboardTopCauses,
  getChartAttentionPoinst,
  getEquipmentAttentionPoinst,
} from "../../../../../services/ciq"
import { ControlExpiring } from "../../components/ControlExpiring"
import { listEquipmentSigma } from "../../../../../services/sigma"
import PageTabs from "../../components/PageTabs"
import Button from "../../../../atoms/Button"
import { RcmpIncompleteRunsAlert } from "../../components/IncompleteRunsAlert"
import { RcmpControlExpiredAlert } from "../../components/ControlExpiredAlert"
import { Flex } from "@stardust-ds/react"

const EquipmentMinimal = ({ dataEquipments, listEquipment }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [tab, setTab] = useState({
    ciq: true,
    sigma: false,
  })
  const navigate = useNavigate()
  const [actionFilter, setActionFilter] = useState({
    alert_quant: true,
    reject_quant: true,
    reject_quali_semi_quant: true,
  })
  const [eqpAttentionPoints, setEqpAttentionPoints] = useState([])
  const [chartAttentionPoints, setChartAttentionPoints] = useState([])
  const [dataFilter, setDataFilter] = useState(null)
  const [equipmentId, setEquipmentId] = useState(null)
  const [equipmentSigma, setEquipmentSigma] = useState([])
  const [cSearch, setCSearch] = useState("")
  const [isSearchActive, setIsSearchActive] = useState(true)

  const [oTopCausesRes, fnTopCausesReq] = useDataApi(getDashboardTopCauses)

  useEffect(() => {
    const filterDashboard = JSON.parse(localStorage.getItem("filterDashboard"))
    const startDate = dataFilter?.startDate
      ? dataFilter?.startDate
      : filterDashboard?.startDate
    const endDate = dataFilter?.endDate ? dataFilter?.endDate : filterDashboard?.endDate

    fnTopCausesReq(startDate, endDate, equipmentId)
  }, [dataFilter, equipmentId])

  const aBreadCrumbs = [
    {
      path: "./",
      name: intl.get("home"),
    },
    {
      bActive: true,
      name: intl.get("ciq.title"),
    },
  ]

  const listElipses = [
    {
      label: intl.get("ciq.list_analytes.exame_analyte"),
      icon: <IAtom width="25" height="22" />,
      onClick: () => navigate("/ciq/list-analytes"),
    },
    {
      label: intl.get("ciq.equipment"),
      icon: <IControl width="25" height="22" />,
      onClick: () => navigate("/ciq/list-equipments"),
    },
    {
      label: intl.get("ciq.controls"),
      icon: <IEqp width="25" height="22" />,
      onClick: () => navigate("/ciq/list-controls"),
    },
  ]

  const topCauses = oTopCausesRes?.data?.data || []

  const getEqpAttentionPoints = async () => {
    try {
      setIsLoading(true)

      const response = await getEquipmentAttentionPoinst()

      setEqpAttentionPoints(response?.data?.data || [])
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }
  const getAttentionPoints = async (dataFilter, equipmentId) => {
    try {
      setIsLoading(true)
      const filterDashboard = JSON.parse(localStorage.getItem("filterDashboard"))
      const startDate = dataFilter?.startDate
        ? dataFilter?.startDate
        : filterDashboard?.startDate
      const endDate = dataFilter?.endDate ? dataFilter?.endDate : filterDashboard?.endDate

      const response = await getChartAttentionPoinst(startDate, endDate, equipmentId)
      setChartAttentionPoints(response?.data?.data.reverse() || [])
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  const fnListEquipmentSigma = async (cSearch) => {
    try {
      setIsLoading(true)

      const resp = await listEquipmentSigma(cSearch)
      setEquipmentSigma(resp.data.data)
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    getAttentionPoints(dataFilter, equipmentId)
    getEqpAttentionPoints(dataFilter, equipmentId)
  }, [dataFilter, equipmentId])

  useEffect(() => {
    fnListEquipmentSigma(cSearch)
  }, [cSearch])

  return (
    <div>
      <RcmpHeader
        elIcon={<IconCiq />}
        cTitlePage={intl.get("ciq.internal_control_quality")}
        aBreadCrumbs={aBreadCrumbs}
        className={styles.header}
      >
        <PageTabs currentTab={1} />
      </RcmpHeader>
      <ContentBlank
        bShowFilter={false}
        bCanSearch={false}
        bSwitchable={false}
        bVisibleIconSearch={false}
        cIconLeftInsideBtn={<></>}
        variantBtn="outline"
        // cWidthBtn="15rem"
        className={styles.contentBlankCustom}
        cText={intl.get("ciq.choose_equipment_release_analysis")}
        aEllipsisContent={listElipses}
        nEizeEllipsis="180px"
        customButtons={[
          <Button
            key="generate-report-button"
            onClick={() => {
              navigate("/ciq/generate-report")
            }}
            variant="outline"
            style={{
              cursor: "pointer",
            }}
          >
            {intl.get("ciq.generete_reports")}
          </Button>,
        ]}
        bHasVideoTutorial={true}
      >
        <div className={styles.wrapperAvaliation}>
          <Flex
            width="100%"
            alignContent="center"
            flexDirection="column"
            justifyContent="center"
            gap="1rem"
          >
            <RcmpControlExpiredAlert />
            <RcmpIncompleteRunsAlert />
          </Flex>
          {dataEquipments.some((it) => it.runs_count > 0) ? (
            <>
              <div className={styles.wrapperEquipment}>
                {dataEquipments.map((equipment) => {
                  return (
                    <button
                      className={styles.containerEquipment}
                      key={equipment.equipment_nid}
                      onClick={() => {
                        navigate(`/ciq/release/${equipment.equipment_nid}`)
                      }}
                    >
                      {equipment.equipment_cname}
                    </button>
                  )
                })}
              </div>

              <FilterDashboard
                defaultValue={[{ label: "Todos", value: "" }]}
                label={intl.get("period")}
                handleChange={setDataFilter}
                onSelect={(e) => setEquipmentId(e?.value)}
                listEquipment={listEquipment}
                nameFilter={"filterDashboard"}
              />

              {isLoading ? (
                <RcmpLoading bShow={true} size={60} />
              ) : (
                <>
                  <div className={styles.wrapperCharts}>
                    <div className={styles.containerCharts}>
                      <h3>{intl.get("ciq.attention_points")}</h3>
                      <FilterAttentionPoints
                        actionFilter={actionFilter}
                        setActionFilter={setActionFilter}
                      />

                      <LineChartComponent
                        actionFilter={actionFilter}
                        chartAttentionPoints={chartAttentionPoints}
                      />
                    </div>
                    <div className={styles.containerCharts}>
                      <h3>{intl.get("ciq.incidenses_root_cause")}</h3>

                      <ParetoChartComponent data={topCauses} />
                    </div>
                  </div>

                  <EquipmentAtention dataEquipmentAtention={eqpAttentionPoints} />
                  <ControlExpiring />
                </>
              )}
            </>
          ) : (
            <>
              <div className={styles.wrapperEquipment}>
                {isLoading ? (
                  <RcmpLoading bShow={true} size={60} />
                ) : (
                  dataEquipments.map((equipment) => {
                    return (
                      <button
                        className={styles.containerEquipment}
                        key={equipment.equipment_nid}
                        onClick={() => {
                          navigate(`/ciq/release/${equipment.equipment_nid}`)
                        }}
                      >
                        {equipment.equipment_cname}
                      </button>
                    )
                  })
                )}
              </div>

              <div className={styles.wrapperInforAttentionAndExpiring}>
                <h2>{intl.get("ciq.attention_equipment")}</h2>
                <div className={styles.contentInforAttentionAndExpiring}>
                  <div className={styles.containerImage}>
                    <img src={NothingIcon} alt={intl.get("ciq.attention_equipment")} />
                  </div>
                  <p> {intl.get("ciq.not_attention_equipment")}</p>
                </div>
              </div>
              <div className={styles.wrapperInforAttentionAndExpiring}>
                <h2>{intl.get("ciq.control_expiring")}</h2>
                <div className={styles.contentInforAttentionAndExpiring}>
                  <div className={styles.containerImage}>
                    <img src={NothingIcon} alt={intl.get("ciq.control_expiring")} />
                  </div>
                  <p> {intl.get("ciq.not_control_expiring")}</p>
                </div>
              </div>
            </>
          )}
        </div>
      </ContentBlank>
    </div>
  )
}
export default EquipmentMinimal
